import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Main from './containers/MainContainer';
import NotFound from './components/NotFound';

const App = () => (
  <div>
    <Switch>
      <Route component={Main} exact path="/" />
      <Route component={Main} path="/home" />
      <Route component={Main} path="/work/:id" />
      <Route component={Main} path="/work" />
      <Route component={Main} path="/about" />
      <Route component={Main} path="/contact" />
      <Route component={NotFound} />
    </Switch>
  </div>
);
export default App;



// WEBPACK FOOTER //
// ./src/App.js